import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import hotelsDescblockApi from '@ibibo/hotels-descblock-api';
import {hotelsPaymentsApi} from '@ibibo/hotels-payments-api';
import hotelsPolicyApi from '@ibibo/hotel-policy-api';
import {
  updateDescblockData,
  updatePaymentsData,
  openPaymentModule,
  setDescblockLoading,
  updateCountryCodes,
  updateHotelsPolicy,
  updateUserVerification
} from './hotels-review-actions';
import {AnyAction} from 'redux';
import {AppState} from '../../../verticals/hotels-dweb/src/shared/store';
import countryCodesApi from '@ibibo/country-codes-api';
import verifyOTP from '@ibibo/verify-otp-api';

export const fetchDescbockData = (
  errCallback,
  successCallback,
): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    let data = {};
    const {common, review, user, details} = getState(); // use relselect
    const { vhid } = details;
    const {userInfo} = user;
    const { account_id } = userInfo;
    const {descblockInput} = review;
    const {destination, checkin, checkout, roomString, country} = common;
    


    // use async and await
    dispatch(setDescblockLoading(true));
    hotelsDescblockApi({
      checkin: checkin.date,
      checkout: checkout.date,
      input: descblockInput,
    })
      .then(response => {
        if (response.success) {
          successCallback && successCallback();
          dispatch(updateDescblockData({...response, loading: false}));
        } else {
          errCallback && errCallback();
        }
      })
      .catch(err => {
        errCallback && errCallback();
      });
    // }
  };
};

export const hotelsPaymentCall = (errCallback, token): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    let data = {};
    const {common, details, review, user} = getState(); // use relselect
    const {userInfo} = user;
    const {descblockInput, descblockResponse, traveller, useGoCash, earlycheckin} = review;
    const {checkin, checkout, roomString} = common;
    // use async and await
    dispatch(updatePaymentsData({loading: true}));
    hotelsPaymentsApi({
      checkin: checkin.date,
      checkout: checkout.date,
      descblockResponse,
      descblockInput,
      roomString,
      travellerInfo: traveller,
      userInfo,
      useGoCash,
      earlycheckin,
      token
    })
      .then((response: object) => {
        if (response.data) {
          dispatch(updatePaymentsData({...response, loading: false}));
          if (response.data.url) {
            window.open(response.data.url, '_self');
          } else {
            dispatch(openPaymentModule());
          }
        } else {
          errCallback && errCallback(response.message);
          dispatch(updatePaymentsData({loading: false}));
        }
      })
      .catch(err => {
        errCallback && errCallback(err.message);
        dispatch(updatePaymentsData({loading: false}));
      });
    // }
  };
};

export const fetchCountryCodes = (): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>) => {
    const defaultValues = [{name: 'India', code: '91'}];

    try {
      const response = await countryCodesApi();
      if (response.data) dispatch(updateCountryCodes(response.data));
      else dispatch(updateCountryCodes(defaultValues));
    } catch {
      dispatch(updateCountryCodes(defaultValues));
    }
  };
};

export const fetchPolicies = (): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const {review} = getState();
    const {
      fwdParams,
      rpc: roomPriceCode,
      v: vendor,
      pay_mode: paymode,
      rtc: roomTypeCode,
      hc: hotelCode,
      paxString,
      strQry,
      hOfferCode,
      gsv,
      gseg,
      cot
    } = review.descblockInput;

    const stringQuerySplit = strQry.length ? strQry.split('-') : null;

    const cancellationPolicyProps = {
      forwardParams: JSON.parse(fwdParams),
      roomPriceCode,
      offercode: hOfferCode,
      vendor,
      paymode,
      roomTypeCode,
      checkinYYYYMMDD: stringQuerySplit[2],
      checkoutYYYYMMDD: stringQuerySplit[3],
      cityCode: stringQuerySplit[1],
      hotelCode,
      paxString,
      gseg,
      gsv,
      cot
    };
    dispatch(updateHotelsPolicy({loading: true}));
    const fetchData = await hotelsPolicyApi(cancellationPolicyProps);
    if (fetchData[0]) dispatch(updateHotelsPolicy({...fetchData[0].data, loading: false}));
  };
};

export const verifyOTPApi = (params, successCallback, errCallback): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>) => {
    try {
      const response = await verifyOTP(params);
      if (response && response.success) {
        dispatch(updateUserVerification(true));
        successCallback();
      } else {
        dispatch(updateUserVerification(false));
        errCallback(response.data && response.data.text_message ? response.data.text_message : 'Error');
      };
    } catch {
      dispatch(updateUserVerification(false));
      errCallback();
    }
  };
};
